import { useState, useEffect } from "react";
import { useAdminAuth } from "../../context/AdminAuthContext";

const ACTION_COLORS = {
  login: "text-green-600",
  login_failed: "text-red-600",
  login_blocked: "text-red-700 font-semibold",
  dashboard_view: "text-blue-600",
  property_view: "text-violet-600",
  inquiry: "text-orange-600",
};

export default function ActivityPage() {
  const { adminAxios } = useAdminAuth();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminAxios.get("/admin/activity").then(({ data }) => setLogs(data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-8 min-h-screen bg-zinc-50">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-zinc-900 tracking-tight">Activity Log</h1>
        <p className="text-sm text-zinc-500 mt-0.5">Last 100 recorded actions</p>
      </div>

      <div className="bg-white border border-zinc-200">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-zinc-100">
              {["Time", "User", "Action", "Details", "IP"].map(h => (
                <th key={h} className="text-left px-4 py-3 text-xs font-semibold text-zinc-500 uppercase tracking-wider">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? <tr><td colSpan={5} className="px-4 py-6 text-zinc-400">Loading...</td></tr>
            : logs.length === 0 ? <tr><td colSpan={5} className="px-4 py-10 text-zinc-400 text-center">No activity recorded yet.</td></tr>
            : logs.map((log) => (
              <tr key={log.id} className="border-b border-zinc-50 hover:bg-zinc-50 transition-colors" data-testid={`activity-row-${log.id}`}>
                <td className="px-4 py-3 text-zinc-400 text-xs whitespace-nowrap">{new Date(log.created_at).toLocaleString()}</td>
                <td className="px-4 py-3 text-zinc-700">{log.user_name || "—"}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs font-medium ${ACTION_COLORS[log.action] || "text-zinc-600"}`}>{log.action}</span>
                </td>
                <td className="px-4 py-3 text-zinc-500 text-xs max-w-xs truncate">{log.details || "—"}</td>
                <td className="px-4 py-3 text-zinc-400 font-mono text-xs">{log.ip || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
